module.exports = __webpack_public_path__ + "static/img_main_event-6ec51c880f4af6abe080dc46f4f48fa2.png";